import { api } from './client'

// Deep Dive analysis — premium-gated Sonnet-powered pattern surface
// shown in the Profile tab. Read is idempotent; generate is user-
// initiated and rate-limited server-side.
export const deepDiveApi = {
  get: (userId, token) => api.get(`/deep-dive/${userId}`, token),
  generate: (token) => api.post('/deep-dive/generate', {}, token),
}
